
import { locale as listingContibutorsLabel } from '../components/listing-activity-contribution/listing-contributors-label/i18n/en';

export const locale = {
    lang: 'en',
    data: {
        ...listingContibutorsLabel.data
    }
};